import * as React             from 'react';

import { ArrowRightVector   } from 'src/components/vector/arrow-right';

import { Container, 
         ItemContainer,
         ItemKeyValue,
         ItemKey,
         ItemValue,
         ItemArrow,
         PieceItemVariants,
         pieceitem_variants } from 'src/components/features/inspection/view/piece-item/ui';

import * as types             from 'src/services/api/types';

import { useAppSelector, 
         storeApi,
         useAppDispatch     } from 'src/store';



type Props = {
  variant: PieceItemVariants;
  piece: types.inspection.Piece;
}
export const PieceItem: React.FC<Props> = ({
  variant,
  piece,
}) => {
  const lookAndFeel = pieceitem_variants.get(variant)!;
  const dispatch = useAppDispatch();

  const selectedPiece = useAppSelector(storeApi.inspection.view.selectors.selectPieceSelected);
  const pieceTitle = useAppSelector((store) => storeApi.inspection.view.selectors.selectPieceTitle(store, piece.guid));
  const pieceText = useAppSelector((store) => storeApi.inspection.view.selectors.selectPieceText(store, piece.guid));
  const isSelected = selectedPiece?.guid === piece.guid;

  const pieceIsError = useAppSelector((store) => storeApi.inspection.view.selectors.selectPieceIsError(store, piece.guid));

  const onSelectHandler = () => {
    dispatch(storeApi.inspection.view.actions.changePieceSelected(piece));
  }

  return (
    <Container lookAndFeel = { lookAndFeel }>
      <ItemContainer lookAndFeel = { lookAndFeel } isSelected = { isSelected } onClick = { onSelectHandler }>
        <ItemKeyValue lookAndFeel = { lookAndFeel }>
          <ItemKey lookAndFeel = { lookAndFeel }>
            { pieceTitle }
          </ItemKey>
          <ItemValue lookAndFeel = { lookAndFeel } isError = { pieceIsError }>
            { pieceText }
          </ItemValue>
        </ItemKeyValue>
        <ItemArrow lookAndFeel = { lookAndFeel }>
          <ArrowRightVector />
        </ItemArrow>
      </ItemContainer>
    </Container>
  );
};
